import ArrowBackIcon from '@mui/icons-material/ArrowBack';
import Breadcrumbs from '@mui/material/Breadcrumbs';
import Chip from '@mui/material/Chip';
import Grid from '@mui/material/Grid';
import IconButton from '@mui/material/IconButton';
import { Theme } from '@mui/material/styles';
import Tooltip from '@mui/material/Tooltip';
import * as React from 'react';
import { makeStyles } from 'tss-react/mui';
import { ApEditorActions, ApLocation } from '../../../sic-lib/reducers/actionPlanEditorReducer';

const useStyles = makeStyles()((theme: Theme) => ({
    root: {
        '& .MuiChip-clickable:hover, & .MuiChip-clickable:focus': {
            //~ theme.palette.secondary.main with light bumped from 48 to 75 'hsl(339, 100%, 75%)'
            backgroundColor: theme.palette.primary.light,
            color: theme.palette.primary.contrastText,
        },
    },
    selected: {
        backgroundColor: theme.palette.primary.main,
        color: theme.palette.primary.contrastText,
        '&.MuiChip-clickable:hover, &.MuiChip-clickable:focus': {
            backgroundColor: theme.palette.primary.main,
            color: theme.palette.primary.contrastText,
        },
    },
    iconButton: {
        padding: '6px',
    },
}));

interface Props {
    apLocation: ApLocation[];
    apDispatch: React.Dispatch<ApEditorActions>;
}

export default function ApEditorTimelineNavigation({ apLocation, apDispatch }: Props) {
    const { classes, cx } = useStyles();

    const handleClick = (event: React.MouseEvent<HTMLButtonElement>) => {
        const nextLocation = apLocation.slice(0, +event.currentTarget.value);

        apDispatch({ type: 'SET_EDITOR_LOCATION_BACK', nextLocation });
    };

    return (
        <Grid container direction="row" wrap="nowrap" alignItems="center" spacing={2}>
            <Grid item xs="auto">
                <Tooltip title="Parent Action">
                    <span>
                        <IconButton
                            disabled={apLocation.length < 1}
                            className={classes.iconButton}
                            value={apLocation.length - 1}
                            onClick={handleClick}
                            size="large"
                        >
                            <ArrowBackIcon />
                        </IconButton>
                    </span>
                </Tooltip>
            </Grid>
            <Grid item xs="auto">
                <Breadcrumbs className={classes.root}>
                    <Chip
                        className={cx(apLocation.length < 1 && classes.selected)}
                        component="button"
                        onClick={handleClick}
                        value={0}
                        size="small"
                        label="Home"
                    />
                    {apLocation.map((itm, idx) => {
                        return (
                            <Chip
                                key={`crumb_${itm.actionIndex}`}
                                className={idx == apLocation.length - 1 ? classes.selected : ''}
                                component="button"
                                onClick={handleClick}
                                value={idx + 1}
                                size="small"
                                label={itm.title}
                            />
                        );
                    })}
                </Breadcrumbs>
            </Grid>
        </Grid>
    );
}
